var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29311",
    "data-name": "Group 29311",
    transform: "translate(-1302 11448.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1302 -11448.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_1_",
    "data-name": "svgexport-17 (1)",
    transform: "translate(1318 -11436.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49741",
    "data-name": "Path 49741",
    d: "M10.319,63.068,0,51.621l3.585-5.344H16.894l3.578,5.334Z",
    transform: "translate(0 -46.277)",
    fill: "#ff3997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49742",
    "data-name": "Path 49742",
    d: "M257.828,63.065l10.15-11.455L264.4,46.277h-6.573Z",
    transform: "translate(-247.507 -46.277)",
    fill: "#d6298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49743",
    "data-name": "Path 49743",
    d: "M0,179.767l10.319,11.447,10.124-11.425Z",
    transform: "translate(0 -174.423)",
    fill: "#ff5ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49744",
    "data-name": "Path 49744",
    d: "M257.828,180.05v11.433l10.122-11.422Z",
    transform: "translate(-247.507 -174.695)",
    fill: "#ff3997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49745",
    "data-name": "Path 49745",
    d: "M155.977,191.752l-4.245-11.425h8.348Z",
    transform: "translate(-145.658 -174.961)",
    fill: "#ff3997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49746",
    "data-name": "Path 49746",
    d: "M14.422,51.643H6.074l4.247-5.366,4.1,5.366ZM0,51.621l6.074.022L3.585,46.277Z",
    transform: "translate(0 -46.277)",
    fill: "#d6298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49747",
    "data-name": "Path 49747",
    d: "M366.342,51.621l-6.074.022,2.489-5.366Z",
    transform: "translate(-345.846 -46.277)",
    fill: "#ff5ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49748",
    "data-name": "Path 49748",
    d: "M257.828,180.327v11.418l4.1-11.418Z",
    transform: "translate(-247.507 -174.961)",
    fill: "#d6298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49749",
    "data-name": "Path 49749",
    d: "M257.828,46.277v5.366h4.1ZM268,51.621l-6.074.022,2.489-5.366Z",
    transform: "translate(-247.507 -46.277)",
    fill: "#bf1b81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondHighlighted);
export default __webpack_public_path__ + "static/media/diamondHighlighted.a2697d1b69906143ccc1bade304c6b79.svg";
export { ForwardRef as ReactComponent };